import { Table, TableContentsChangedEvent, TableRow, TableRowCreationEvent, TableRowMode } from "@mcleod/components";
import { AutogenLayoutCreditOverrides } from "./autogen/AutogenLayoutCreditOverrides";
import { CustomerOptions } from "./CustomerOptions";
import { Alignment } from "@mcleod/core";

export class CreditOverrides extends AutogenLayoutCreditOverrides {
    override onLoad() {
        this.tableCreditOverride.addContentsChangedListener((event: TableContentsChangedEvent) => {
            this.tableCreditOverrideOnContentsChanged(event)
        });
    }

    tableCreditOverrideOnContentsChanged(event: TableContentsChangedEvent) {
        this.setTabCount();
    }

    setTabCount() {
        const customerOptions = this.getParentLayout() as CustomerOptions;
        const overrideTab = customerOptions.tabCreditOverrides;
        customerOptions.styleTab(overrideTab, true);
        overrideTab.headingLabel.fillRow = false;
        overrideTab["countLabel"].text = this.tableCreditOverride.rowCount;
    }

    tableCreditOverrideOnRowDisplay(event) {
        const tableRow = event.getTableRow();
        const reviewDate = tableRow.findComponentById("textboxReviewDate");
        reviewDate.required = false;
        const reviewUser = tableRow.findComponentById("textboxUserId");
        reviewUser.required = false;
        if (tableRow.mode !== TableRowMode.QUICK_ADD) {
            const comments = tableRow.findComponentById("textboxComments");
            comments.required = false;
        }
    }

    getRowCount(): number {
        return this.tableCreditOverride.rowCount;
    }
}
